/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Chat_Prompt_Placeholder_AgendaInputs */



/**
* | output |
* | --- |
* | "What's on your plate today?" |
*
* @param {Chat_Prompt_Placeholder_AgendaInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const chat_prompt_placeholder_agenda = /** @type {((inputs?: Chat_Prompt_Placeholder_AgendaInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Chat_Prompt_Placeholder_AgendaInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return /** @type {LocalizedString} */ ("Was steht heute an?")
	return /** @type {LocalizedString} */ ("What's on your plate today?")
});